import { gql } from '@apollo/client';

export const GET_CONVERSATION_ID = gql`
  query Chat_getConversationId {
    chat_getConversationId {
      conversationId
    }
  }
`;

export const GET_BOOLEAN_QUERY_CONVERSATION_ID = gql`
  query Chat_getBooleanConversationId {
    chat_getBooleanConversationId {
      conversationId
    }
  }
`;
